import { Head, Link, useForm } from '@inertiajs/react'
import { AuthShell, type ValuePanel } from '@/components/auth/AuthShell'
import { Button } from '@/components/ui/Button'
import { Field } from '@/components/ui/Field'

type Labels = {
  title: string
  explanation: string
  email_label: string
  submit: string
  submit_processing: string
  back_link: string
}

type Props = {
  labels: Labels
  value_panel: ValuePanel
}

export default function PasswordNew({ labels, value_panel }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    email_address: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/passwords')
  }

  return (
    <>
      <Head title={labels.title} />
      <AuthShell valuePanel={value_panel}>
        <h1 className="font-display text-3xl text-ink">{labels.title}</h1>
        <p className="mt-3 text-sm leading-relaxed text-ink-soft">{labels.explanation}</p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-5">
          <Field
            label={labels.email_label}
            name="email_address"
            type="email"
            value={data.email_address}
            onChange={(e) => setData('email_address', e.target.value)}
            required
            autoFocus
            error={errors.email_address}
          />
          <Button type="submit" disabled={processing} className="w-full disabled:opacity-60">
            {processing ? labels.submit_processing : labels.submit}
          </Button>
        </form>

        <Link href="/session/new" className="mt-6 inline-block text-sm font-semibold text-ink-soft hover:text-ink">
          {labels.back_link}
        </Link>
      </AuthShell>
    </>
  )
}
